import type { TFunction } from 'i18next';

/**
 * Oznake Sentryjevega obrazca za povratno informacijo (`feedbackIntegration`).
 *
 * T2444: vsako besedilo, ki ga obrazec izpiše, mora biti podano tu — česar ne
 * podamo, Sentry vzame iz svojih angleških privzetih vrednosti (»Name«,
 * »Email«, »(required)«). Imena opcij so iz `@sentry/core`
 * (`types-hoist/feedback/config.d.ts`, `FeedbackTextConfiguration`).
 *
 * `isRequiredLabel` Sentry pripne oznaki vsakega obveznega polja sam (opis je
 * vedno obvezen), zato `messageLabel` ne nosi svojega »(obvezno)«.
 */
export function sentryFeedbackLabels(t: TFunction) {
  return {
    formTitle: t('sentry_feedback.title', { defaultValue: 'Pošlji povratno informacijo' }),
    submitButtonLabel: t('sentry_feedback.submit_button', { defaultValue: 'Pošlji' }),
    cancelButtonLabel: t('sentry_feedback.cancel_button', { defaultValue: 'Prekliči' }),
    addScreenshotButtonLabel: t('sentry_feedback.screenshot_button', { defaultValue: 'Dodaj posnetek zaslona' }),
    removeScreenshotButtonLabel: t('sentry_feedback.remove_screenshot_button', { defaultValue: 'Odstrani posnetek' }),
    nameLabel: t('sentry_feedback.name_label', { defaultValue: 'Ime' }),
    namePlaceholder: t('sentry_feedback.name_placeholder', { defaultValue: 'Vaše ime' }),
    emailLabel: t('sentry_feedback.email_label', { defaultValue: 'E-naslov' }),
    emailPlaceholder: t('sentry_feedback.email_placeholder', { defaultValue: 'vas@email.com' }),
    messageLabel: t('sentry_feedback.message_label', { defaultValue: 'Opis' }),
    messagePlaceholder: t('sentry_feedback.message_placeholder', { defaultValue: 'Kaj ste pričakovali?' }),
    isRequiredLabel: t('sentry_feedback.required', { defaultValue: '(obvezno)' }),
    successMessageText: t('sentry_feedback.success_message', { defaultValue: 'Hvala za povratno informacijo!' }),
  };
}
